/* Touch layouts must never inherit sticky :hover after a tap. Gate only
   the hover pseudo-class, preserving base styles, focus-visible and action
   states (loading, selected, added-to-cart). Desktop rules remain intact. */
(() => {
  const mode = matchMedia('(max-width:1200px), (hover:none), (pointer:coarse)');
  const attribute = 'data-ak-touch-ui';
  const guard = ':not(:where([data-ak-touch-ui],[data-ak-touch-ui] *))';
  const hover = /(?<!\\):hover\b/g;
  function updateMode() {
    document.documentElement.toggleAttribute(attribute, mode.matches);
  }
  function gateRules(rules) {
    for (const rule of rules) {
      if (rule.selectorText && rule.selectorText.includes(':hover') && !rule.selectorText.includes(guard)) {
        const selector = rule.selectorText.replace(hover, `:hover${guard}`);
        if (selector !== rule.selectorText) rule.selectorText = selector;
      }
      if (rule.cssRules) gateRules(rule.cssRules);
      if (rule.styleSheet) gateSheet(rule.styleSheet);
    }
  }
  function gateSheet(sheet) {
    try { if (sheet.cssRules) gateRules(sheet.cssRules); }
    catch (_) { /* Third-party font stylesheets are not readable or interactive. */ }
  }
  function scan() {
    for (const sheet of document.styleSheets) gateSheet(sheet);
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; scan(); });
  }
  updateMode();
  mode.addEventListener('change', updateMode);
  scan();
  document.addEventListener('load', event => {
    if (event.target.matches?.('link[rel="stylesheet"]')) gateSheet(event.target.sheet);
  }, true);
  document.addEventListener('DOMContentLoaded', scan, {once:true});
  // Sections, search results and cart widgets may add their own inline CSS.
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeName === 'STYLE' ||
      [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('style,link[rel="stylesheet"]') || node.querySelector('style,link[rel="stylesheet"]'))))) schedule();
  }).observe(document.documentElement, {childList:true, subtree:true, characterData:true});
  // Also cover rules inserted by a widget directly through CSSStyleSheet.
  document.addEventListener('pointerdown', () => { if (mode.matches) scan(); }, {capture:true, passive:true});
  const style = document.createElement('style');
  style.textContent = 'html[data-ak-touch-ui] :is(a,button,input,select,label,[role="button"]) {-webkit-tap-highlight-color:transparent;}';
  document.head.append(style);
})();
